import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { getCurrentBrandFromState } from "assets/js/scenes/brand/utils";
import BrandChannelConfiguration from "./ChannelConfigurations/BrandChannelConfiguration";
import { USER_CHANNELS } from "../const";
import LogoBrandElement from "../components/brandElements/LogoBrandElement";
import ColorBrandElement from "../components/brandElements/ColorBrandElement";
import { DEFAULT_COLORS } from "assets/js/scenes/brand/const";
import ConfigurationSection from "../components/ConfigurationSection";
import { I18n } from "react-redux-i18n";

const basePath = USER_CHANNELS.SMART_EMAIL_TEMPLATES;
export const SmartEmailTemplates = (props) => {
	const styleBasePath = basePath + ".styles";
	const base = props.localBrand ? props.localBrand[basePath] : null;
	const defaultBase = props.brand ? props.brand[basePath] : null;
	const styleBased = base?.styles;
	const styleDefaultBase = defaultBase?.styles;
	const channelStringsKey = "smart-templates";
	const renderColors = () => {
		const sections = [
			{
				name: I18n.t("app-brand-editable-section-text-TXT"),
				colors: [
					{
						name: "headline_text",
						placeholderColor: DEFAULT_COLORS.BLACK,
					},
					{
						name: "p_text",
						placeholderColor: DEFAULT_COLORS.BLACK,
					},
					{
						name: "link",
						placeholderColor: DEFAULT_COLORS.BLACK,
					},
				],
			},
			{
				name: I18n.t("app-brand-editable-section-button-TXT"),
				colors: [
					{
						name: "button_text",
						placeholderColor: DEFAULT_COLORS.WHITE,
					},
					{
						name: "button_bg",
						placeholderColor: DEFAULT_COLORS.BLACK,
					},
				],
			},
			/*{
				name: I18n.t("app-brand-editable-section-background-TXT"),
				colors: [
					{
						name: "content_bg",
						placeholderColor: DEFAULT_COLORS.WHITE,
					},
					{
						name: "page_bg",
						placeholderColor: DEFAULT_COLORS.WHITE,
					},
				],
			},*/
		];
		return sections.map((section) => {
			return (
				<>
					<ConfigurationSection text={section.name}>
						{section.colors.map((color) => {
							return (
								<ColorBrandElement
									name={color.name}
									channelStringsKey={channelStringsKey}
									path={styleBasePath + `.${color.name}_color`}
									color={styleBased?.[`${color.name}_color`]}
									defaultColor={styleDefaultBase?.[`${color.name}_color`]}
									placeholderColor={color.placeholderColor}
									goToSDK={props.goToSDK}
								/>
							);
						})}
					</ConfigurationSection>
				</>
			);
		});
	};
	return (
		<BrandChannelConfiguration
			{...props}
			channelStringsKey={channelStringsKey}
			basePath={basePath}
			preview={null}
		>
			<ConfigurationSection text="logo">
				<LogoBrandElement
					channelStringsKey={channelStringsKey}
					name="logo"
					imgObj={base?.["logo"]}
					defaultImgObj={defaultBase?.["logo"]}
					path={basePath + ".logo"}
					goToSDK={props.goToSDK}
					usePrimary
				/>
			</ConfigurationSection>
			{renderColors()}
		</BrandChannelConfiguration>
	);
};

SmartEmailTemplates.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	userBrandSDK: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
	preview: PropTypes.func,
	accountId: PropTypes.string,
	goToSDK: PropTypes.func,
};

SmartEmailTemplates.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				brand: getCurrentBrandFromState(state),
				resellerName: state.brand?.name,
				accountId: state.global.account.id,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(SmartEmailTemplates)
);
